export const BTN_KEY_CHAIN_CHANGE = 1;
export const BTN_KEY_UPDATE_RATE = 2;
export const BTN_KEY_PREVIEW = 3;
export const BTN_KEY_APPROVE = 4;
export const BTN_KEY_APPROVE_RETRY = 5;
export const BTN_KEY_TRANSFER = 6;
export const BTN_KEY_TRANSFER_RETRY = 7;
export const BTN_KEY_RETURN_SWAP_FORM = 8;
export const BTN_START_FROM_ROUTE = 9;
